import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import PageHero from '../../components/feature/sections/PageHero';
import TrustBar from '../../components/feature/sections/TrustBar';
import LocalServices from './components/LocalServices';
import AIAnswerBlock, { AIAnswerItem } from '../../components/feature/sections/AIAnswerBlock';
import ProcessSection from '../../components/feature/sections/ProcessSection';
import WhyChooseUs from '../../components/feature/sections/WhyChooseUs';
import ServiceAreas from '../../components/feature/sections/ServiceAreas';
import Testimonials from '../../components/feature/sections/Testimonials';
import FAQSection, { FAQItem } from '../../components/feature/sections/FAQSection';
import FinalCTA from '../../components/feature/sections/FinalCTA';

const aiItems: AIAnswerItem[] = [
  {
    question: 'Who provides flooring installation in Freehold, NJ?',
    answer: 'Value Carpet Inc offers professional flooring installation services in Freehold, NJ, including carpet, hardwood, laminate, vinyl, and marine specialty flooring. Their team ensures precise installation and high-quality results tailored to local homes and businesses in Monmouth County.',
  },
  {
    question: 'What flooring services are available in Freehold, NJ?',
    answer: 'Value Carpet Inc provides carpet installation, hardwood flooring, laminate, vinyl, carpet tiles, marine carpet, and floor replacement and repairs throughout Freehold and the surrounding Monmouth County, NJ region.',
  },
  {
    question: 'Do you serve areas near Freehold, NJ?',
    answer: 'Yes. In addition to Freehold, Value Carpet Inc serves Howell, Manalapan, Marlboro, Colts Neck, Jackson, Lakewood, Toms River, Old Bridge, Red Bank, and many other communities throughout Monmouth and Ocean Counties.',
  },
  {
    question: 'Why hire a local flooring company in Freehold, NJ?',
    answer: 'A local specialist in Freehold understands the regional housing styles, can respond quickly, and provides personalized service backed by community reputation. Value Carpet Inc has served the Freehold area with consistent quality and reliable installation.',
  },
];

const faqs: FAQItem[] = [
  {
    q: 'How do I find flooring installers in Freehold, NJ?',
    a: 'Look for experienced, licensed flooring professionals with strong local reviews and proven installation quality. Value Carpet Inc serves Freehold, NJ with reliable, high-quality flooring services tailored to local homes and businesses.',
  },
  {
    q: 'How much does carpet installation cost in Freehold, NJ?',
    a: 'Carpet installation costs in Freehold, NJ depend on carpet type, square footage, and preparation requirements. Value Carpet Inc provides free consultations with accurate, no-obligation quotes tailored to your space and needs.',
  },
  {
    q: 'How long does flooring installation take in Freehold?',
    a: 'Most flooring projects in Freehold are completed within one to two days depending on room size and material type. Larger projects or those requiring subfloor repairs may require additional time. Value Carpet Inc provides timeline estimates upfront.',
  },
  {
    q: 'Does Value Carpet Inc serve commercial businesses in Freehold, NJ?',
    a: 'Yes. Value Carpet Inc installs commercial flooring for businesses in Freehold and Monmouth County — including carpet tiles, vinyl plank, and specialty flooring suitable for offices, retail, and high-traffic commercial environments.',
  },
  {
    q: 'What areas near Freehold does Value Carpet Inc service?',
    a: 'Value Carpet Inc serves communities throughout Monmouth and Ocean Counties including Howell, Manalapan, Marlboro, Colts Neck, Jackson, Lakewood, Toms River, Old Bridge, Red Bank, Asbury Park, and surrounding areas.',
  },
];

export default function FreeholdLocationPage() {
  return (
    <div className="min-h-screen bg-cream font-sans">
      <Navbar />
      <main>
        <PageHero
          title={`Flooring Installation in Freehold, NJ`}
          subtitle="Professional carpet, hardwood, vinyl, and specialty flooring installation for residential and commercial spaces throughout Freehold and Monmouth County."
          tag="Serving Freehold, NJ · Monmouth County"
          imageSrc="https://public.readdy.ai/ai/img_res/b4d4bf1c52d159f510b75487c6d47d23.jpg"
          imageAlt="Flooring installation in Freehold, NJ"
        />
        <TrustBar />
        <LocalServices />
        <AIAnswerBlock title="Flooring in Freehold, NJ — Explained" items={aiItems} />
        <ProcessSection />
        <WhyChooseUs />
        <ServiceAreas />
        <Testimonials />
        <FAQSection title="Freehold, NJ Flooring FAQs" faqs={faqs} />
        <FinalCTA />
      </main>
      <Footer />
    </div>
  );
}
